import React from 'react';

import { Box, Typography, useTheme, Divider } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Image from 'src/components/atoms/image';
import NextLink from 'src/components/atoms/link';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type ContactProps = {
  phoneNumberAndOfficeHours?: {
    phone: string;
    phone_hours: string;
    social_hours: string;
  };
  FACEBOOK_URL: string;
  LINE_URL: string;
};

const Contact = ({ phoneNumberAndOfficeHours, FACEBOOK_URL, LINE_URL }: ContactProps) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Typography variant="h5" color={theme.palette.primaryV2.main}>
            {t('home.footer.contact_us')}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <Typography
              href="/faq"
              variant="body2lanna"
              color={theme.palette.primaryV2.main}
              component={NextLink}
              sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <FontAwesomeIcon style={{ fontSize: '18px' }} icon="fa-regular fa-circle-question" />{' '}
              {t('home.footer.faq')}
            </Typography>
            <Typography
              href={`tel:${phoneNumberAndOfficeHours?.phone}`}
              target="_blank"
              variant="body2lanna"
              color={theme.palette.primaryV2.main}
              rel="noreferrer"
              component={NextLink}
              sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <FontAwesomeIcon style={{ fontSize: '18px' }} icon="fa-regular fa-phone" />{' '}
              {phoneNumberAndOfficeHours?.phone} ({phoneNumberAndOfficeHours?.phone_hours})
            </Typography>
          </Box>
        </Box>
        <Box>
          <Divider />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            href={FACEBOOK_URL}
            target="_blank"
            component={NextLink}
            rel="noreferrer"
            sx={{ display: 'flex', gap: '8px' }}
            variant="body2lanna"
            color={theme.palette.primaryV2.main}
          >
            <Image
              style={{ width: '18px', height: '18px' }}
              src="/static/icons/footer/facebook-contact.png"
              alt="facebook-contact"
            />
            SkillLane
          </Typography>
          <Typography
            href={LINE_URL}
            target="_blank"
            component={NextLink}
            rel="noreferrer"
            sx={{ display: 'flex', gap: '8px' }}
            variant="body2lanna"
            color={theme.palette.primaryV2.main}
          >
            <Image style={{ width: '18px', height: '18px' }} alt="line-icon" src="/static/icons/footer/line-icon.png" />
            @SkillLane
          </Typography>
          <Typography
            href="mailto:info@SkillLane.com"
            target="_blank"
            component={NextLink}
            rel="noreferrer"
            sx={{ display: 'flex', gap: '8px' }}
            variant="body2lanna"
            color={theme.palette.primaryV2.main}
          >
            <FontAwesomeIcon style={{ fontSize: '18px' }} icon="fa-regular fa-envelope" /> info@SkillLane.com
          </Typography>
          <Typography variant="body2lanna" color={theme.palette.primaryV2.main}>
            ({phoneNumberAndOfficeHours?.social_hours})
          </Typography>
        </Box>
        <Box>
          <Divider />
        </Box>
      </Box>
    </>
  );
};

export default Contact;
